import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EXCESS_TYPES, PREMIUM_REVIEW_TOGGLE_STYLE } from '../../../../../ahm-constants/ui';
import { Label, PaymentOption, PaymentOptionsWrapper, SoftBundleListbox } from '../../choose-your-cover/styles';
import { ProductType } from '../../../../../types/product';
import CustomerActions from '../../../../../actions/customer';
import getFrequencyOptions from '../../../../../utils/get-frequency-options';
import hospitalExcessToOptions from '../../../../../utils/hospital-excess-to-options';
import PremiumReviewToggle from '../../../../../components/premium-review-toggle-wrapper';
import selectCustomer from '../../../../../selectors/select-customer';

const PaymentToggles = ({ productType }: { productType: ProductType['type'] }) => {
  const { frequency, hospitalExcess } = useSelector(selectCustomer);

  const dispatch = useDispatch();

  const onChangeFrequency = useCallback(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'newFrequency' implicitly has an 'any' type.
    (newFrequency) => {
      dispatch(CustomerActions.changeFrequency(newFrequency));
    },
    [dispatch],
  );

  const onChangeExcess = useCallback(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'excess' implicitly has an 'any' type.
    (excess) => {
      dispatch(CustomerActions.changeHospitalExcess(excess));
    },
    [dispatch],
  );

  return (
    <PaymentOptionsWrapper>
      <PremiumReviewToggle
        hasEvenSpacing
        hasMargin={false}
        showBackground={false}
        type={PREMIUM_REVIEW_TOGGLE_STYLE.SOFT_BUNDLE_PAGE}
      />
      <Label>Paying</Label>
      <PaymentOption>
        <SoftBundleListbox
          label="frequency"
          ariaLabel="frequency"
          value={frequency}
          options={getFrequencyOptions({ endText: 'ly' })}
          onChange={onChangeFrequency}
        />
      </PaymentOption>
      {productType === PRODUCT_TYPE.HOSPITAL && (
        <>
          <Label>Excess</Label>
          <PaymentOption>
            <SoftBundleListbox
              label="excess"
              ariaLabel="excess"
              value={hospitalExcess}
              options={hospitalExcessToOptions(EXCESS_TYPES)}
              onChange={onChangeExcess}
            />
          </PaymentOption>
        </>
      )}
    </PaymentOptionsWrapper>
  );
};

export default PaymentToggles;
